<template>
  <div class="block-2d d-flex">
    <div class="op4"  style="position: absolute; top:0; right: 0;">
      <button @click="initAll()">initAll</button>
      <button @click="replay()">replay</button>
      <button @click="getRaceRepalyData()">getRaceRepalyData</button>
    </div>

    <div class="rank-list mr-3" style="width: 280px;">
      <div
        v-for="(item,index) of rank_list"
        class="mb-2"
        style="position: relative;"
        :key="index"
        >
        <span class="abs" style="right: 5px;">
          Gate: {{item.gate}}
        </span>
        <horseItemCardSmall
          :data="transHorseData(demo_horse)"
          :cfg_size_small="true"
          :cfg_no_link="true"
          class="w-100"
        />
      </div>
    </div>

    <div class="race-box" :style="`height: ${comp_cfg.ui_height}px;`">

      <div class="race-map" :style="`height: ${ui_raced_max_now * comp_cfg.ui_height_rate}px;`">

        <div 
          :class="['line-item',{'no-border': item == 0}]"
          v-for="(item,index) of ui_line_gap"
          :key="'line-'+index"
          :style="`bottom: ${item * comp_cfg.ui_height_rate}px;`"
          >
          <span v-if="item == 0">
            Start
          </span>
          <span v-else-if="item % 100 === 0">
            {{item + ' m'}}
          </span>
          
        </div>

        <div>
          <span
            v-for="(item,index) of num_raced_now"
            :key="'horse-'+index"
            class="horse-item"
            :style="`left: ${parseInt((1+index)*(85/num_raced_now.length))}%;bottom: ${item * comp_cfg.ui_height_rate}px;`"
            >
            {{index + 1}}
          </span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

// let cfg = {
//   
//   num_race_max: 1500, // 最大数（终点数）
//   num_race_gap: 100, // 多少米一个线 
//   timer_uni: 100, // 计时器细粒度
// }
let race_data = {
  0: [0,0,0,0,0,0,0,0,0,0,0,0],
  1000: [15,35,35,45,95,95,85,95,15,15,45,55],
  2000: [91,93,93,94,99,99,98,99,91,91,94,95],
  3000: [121,133,113,154,149,139,168,119,131,121,124,115],
  4000: [1121,1133,1113,1154,1149,1139,1168,1119,1131,1121,1124,1115],
  5000: [1234,1500,1413,1354,1249,1139,1368,1419,1431,1321,1124,1215],
  6000: [1500,1500,1500,1500,1500,1500,1368,1419,1431,1321,1124,1500],
  7000: [1500,1500,1500,1500,1500,1500,1500,1500,1500,1500,1500,1500],
}

let race_data_new = {
  0: [0,0,0,0,0,0,0,0,0,0,0,0],
}
for(let i = 100; i <= 5000; i+= 100){
  
  let last_key = null
  for(let key in race_data_new){
    last_key = key
  }
  let data_new = JSON.parse(JSON.stringify(race_data_new[last_key]))

  data_new = data_new.map(item => item + parseInt(Math.random()*10))

  race_data_new[i] = data_new
}

console.log(race_data_new)

import horseItemCardSmall from '@/views/_cp_busi/horse_item_card_small.vue'

export default {
  name: 'replay2d',
  components: {
    horseItemCardSmall,
  },
  props: [
    'cfg',
    'race_id',
    // 'race_data',
  ],
  data() {
    return {
      demo_horse: {"raceID":0,"horseNumber":5,"startedAt":1631178128,"createdAt":1631111816,"price":"0.000001","status":2,"raceLevel":0,"raceLevel_str":"Griffin","eventName":"NY Race 2","location":"NY2","distance":0,"distance_str":"1000m","real_horses":[{"__typename":"Horse","birthTime":"1631110748","bloodline":2,"breedtype":0,"coatcolor":"0","firstNumber":"0","gender":0,"genotype":"235","id":"1","matronId":"0","name":"second horse","offsprings":["3","5"],"points":"20","racesNumber":"1","secondNumber":"1","sireId":"0","thirdNumber":"0"},{"__typename":"Horse","birthTime":"1631110820","bloodline":1,"breedtype":0,"coatcolor":"0","firstNumber":"0","gender":1,"genotype":"262","id":"2","matronId":"0","name":"third horse","offsprings":["3"],"points":"17","racesNumber":"1","secondNumber":"0","sireId":"0","thirdNumber":"0"},{"__typename":"Horse","birthTime":"1631111132","bloodline":2,"breedtype":1,"coatcolor":"0","firstNumber":"1","gender":1,"genotype":"268","id":"3","matronId":"2","name":"forth horse","offsprings":[],"points":"21","racesNumber":"1","secondNumber":"0","sireId":"1","thirdNumber":"0"},{"__typename":"Horse","birthTime":"1631111248","bloodline":0,"breedtype":0,"coatcolor":"0","firstNumber":"0","gender":1,"genotype":"62","id":"4","matronId":"0","name":"fifth horse","offsprings":["5"],"points":"18","racesNumber":"1","secondNumber":"0","sireId":"0","thirdNumber":"0"},{"__typename":"Horse","birthTime":"1631111332","bloodline":2,"breedtype":1,"coatcolor":"0","firstNumber":"0","gender":1,"genotype":"268","id":"5","matronId":"4","name":"six horse","offsprings":[],"points":"19","racesNumber":"1","secondNumber":"0","sireId":"1","thirdNumber":"1"}],"horses":[{"tokenID":3,"name":"forth horse","gender":1,"gender_str":"mare","is_male":false,"bloodline":2,"bloodline_str":"Finney","genotype":268,"breedtype":1,"breedtype_str":"Legendary","coatcolourR":0,"coatcolourG":0,"coatcolourB":0,"birthTime":1631111132,"matronId":2,"sireId":1,"offsprings":[],"horseRaceInfo":{"raced":"__vue_devtool_undefined__","racesNumber":1,"points":21,"firstNumber":1,"secondNumber":0,"thirdNumber":0}},{"tokenID":1,"name":"second horse","gender":0,"gender_str":"stallion","is_male":true,"bloodline":2,"bloodline_str":"Finney","genotype":235,"breedtype":0,"breedtype_str":"Genesis","coatcolourR":0,"coatcolourG":0,"coatcolourB":0,"birthTime":1631110748,"matronId":0,"sireId":0,"offsprings":[],"horseRaceInfo":{"raced":"__vue_devtool_undefined__","racesNumber":1,"points":20,"firstNumber":0,"secondNumber":1,"thirdNumber":0}},{"tokenID":5,"name":"six horse","gender":1,"gender_str":"mare","is_male":false,"bloodline":2,"bloodline_str":"Finney","genotype":268,"breedtype":1,"breedtype_str":"Legendary","coatcolourR":0,"coatcolourG":0,"coatcolourB":0,"birthTime":1631111332,"matronId":4,"sireId":1,"offsprings":[],"horseRaceInfo":{"raced":"__vue_devtool_undefined__","racesNumber":1,"points":19,"firstNumber":0,"secondNumber":0,"thirdNumber":1}},{"tokenID":4,"name":"fifth horse","gender":1,"gender_str":"mare","is_male":false,"bloodline":0,"bloodline_str":"Nakamoto","genotype":62,"breedtype":0,"breedtype_str":"Genesis","coatcolourR":0,"coatcolourG":0,"coatcolourB":0,"birthTime":1631111248,"matronId":0,"sireId":0,"offsprings":[],"horseRaceInfo":{"raced":"__vue_devtool_undefined__","racesNumber":1,"points":18,"firstNumber":0,"secondNumber":0,"thirdNumber":0}},{"tokenID":2,"name":"third horse","gender":1,"gender_str":"mare","is_male":false,"bloodline":1,"bloodline_str":"Szabo","genotype":262,"breedtype":0,"breedtype_str":"Genesis","coatcolourR":0,"coatcolourG":0,"coatcolourB":0,"birthTime":1631110820,"matronId":0,"sireId":0,"offsprings":[],"horseRaceInfo":{"raced":"__vue_devtool_undefined__","racesNumber":1,"points":17,"firstNumber":0,"secondNumber":0,"thirdNumber":0}}],"getRaceHorseIds":[{"tokenID":3,"name":"forth horse","gender":1,"gender_str":"mare","is_male":false,"bloodline":2,"bloodline_str":"Finney","genotype":268,"breedtype":1,"breedtype_str":"Legendary","coatcolourR":0,"coatcolourG":0,"coatcolourB":0,"birthTime":1631111132,"matronId":2,"sireId":1,"offsprings":[],"horseRaceInfo":{"raced":"__vue_devtool_undefined__","racesNumber":1,"points":21,"firstNumber":1,"secondNumber":0,"thirdNumber":0}},{"tokenID":1,"name":"second horse","gender":0,"gender_str":"stallion","is_male":true,"bloodline":2,"bloodline_str":"Finney","genotype":235,"breedtype":0,"breedtype_str":"Genesis","coatcolourR":0,"coatcolourG":0,"coatcolourB":0,"birthTime":1631110748,"matronId":0,"sireId":0,"offsprings":[],"horseRaceInfo":{"raced":"__vue_devtool_undefined__","racesNumber":1,"points":20,"firstNumber":0,"secondNumber":1,"thirdNumber":0}},{"tokenID":5,"name":"six horse","gender":1,"gender_str":"mare","is_male":false,"bloodline":2,"bloodline_str":"Finney","genotype":268,"breedtype":1,"breedtype_str":"Legendary","coatcolourR":0,"coatcolourG":0,"coatcolourB":0,"birthTime":1631111332,"matronId":4,"sireId":1,"offsprings":[],"horseRaceInfo":{"raced":"__vue_devtool_undefined__","racesNumber":1,"points":19,"firstNumber":0,"secondNumber":0,"thirdNumber":1}},{"tokenID":4,"name":"fifth horse","gender":1,"gender_str":"mare","is_male":false,"bloodline":0,"bloodline_str":"Nakamoto","genotype":62,"breedtype":0,"breedtype_str":"Genesis","coatcolourR":0,"coatcolourG":0,"coatcolourB":0,"birthTime":1631111248,"matronId":0,"sireId":0,"offsprings":[],"horseRaceInfo":{"raced":"__vue_devtool_undefined__","racesNumber":1,"points":18,"firstNumber":0,"secondNumber":0,"thirdNumber":0}},{"tokenID":2,"name":"third horse","gender":1,"gender_str":"mare","is_male":false,"bloodline":1,"bloodline_str":"Szabo","genotype":262,"breedtype":0,"breedtype_str":"Genesis","coatcolourR":0,"coatcolourG":0,"coatcolourB":0,"birthTime":1631110820,"matronId":0,"sireId":0,"offsprings":[],"horseRaceInfo":{"raced":"__vue_devtool_undefined__","racesNumber":1,"points":17,"firstNumber":0,"secondNumber":0,"thirdNumber":0}}],"getRaceResult":[{"tokenID":3,"name":"forth horse","gender":1,"gender_str":"mare","is_male":false,"bloodline":2,"bloodline_str":"Finney","genotype":268,"breedtype":1,"breedtype_str":"Legendary","coatcolourR":0,"coatcolourG":0,"coatcolourB":0,"birthTime":1631111132,"matronId":2,"sireId":1,"offsprings":[],"horseRaceInfo":{"raced":"__vue_devtool_undefined__","racesNumber":1,"points":21,"firstNumber":1,"secondNumber":0,"thirdNumber":0}},{"tokenID":1,"name":"second horse","gender":0,"gender_str":"stallion","is_male":true,"bloodline":2,"bloodline_str":"Finney","genotype":235,"breedtype":0,"breedtype_str":"Genesis","coatcolourR":0,"coatcolourG":0,"coatcolourB":0,"birthTime":1631110748,"matronId":0,"sireId":0,"offsprings":[],"horseRaceInfo":{"raced":"__vue_devtool_undefined__","racesNumber":1,"points":20,"firstNumber":0,"secondNumber":1,"thirdNumber":0}},{"tokenID":5,"name":"six horse","gender":1,"gender_str":"mare","is_male":false,"bloodline":2,"bloodline_str":"Finney","genotype":268,"breedtype":1,"breedtype_str":"Legendary","coatcolourR":0,"coatcolourG":0,"coatcolourB":0,"birthTime":1631111332,"matronId":4,"sireId":1,"offsprings":[],"horseRaceInfo":{"raced":"__vue_devtool_undefined__","racesNumber":1,"points":19,"firstNumber":0,"secondNumber":0,"thirdNumber":1}},{"tokenID":4,"name":"fifth horse","gender":1,"gender_str":"mare","is_male":false,"bloodline":0,"bloodline_str":"Nakamoto","genotype":62,"breedtype":0,"breedtype_str":"Genesis","coatcolourR":0,"coatcolourG":0,"coatcolourB":0,"birthTime":1631111248,"matronId":0,"sireId":0,"offsprings":[],"horseRaceInfo":{"raced":"__vue_devtool_undefined__","racesNumber":1,"points":18,"firstNumber":0,"secondNumber":0,"thirdNumber":0}},{"tokenID":2,"name":"third horse","gender":1,"gender_str":"mare","is_male":false,"bloodline":1,"bloodline_str":"Szabo","genotype":262,"breedtype":0,"breedtype_str":"Genesis","coatcolourR":0,"coatcolourG":0,"coatcolourB":0,"birthTime":1631110820,"matronId":0,"sireId":0,"offsprings":[],"horseRaceInfo":{"raced":"__vue_devtool_undefined__","racesNumber":1,"points":17,"firstNumber":0,"secondNumber":0,"thirdNumber":0}}],"mark_live":false},

      race_data: race_data,

      mark_query_data_start: 0,
      mark_query_data_step: 5000,

      list_horse: [],

      timer: null,

      // 当前时间
      time_now: 0,
      // 数据中的 上一个时间点
      time_point_prev: 0,
      // 数据中的 下一个时间点
      time_point_next: 0,
      // 数据中的 最后一个时间点
      time_point_max: 1/0,


      // 当前跑出距离
      num_raced_now: [0,0,0,0,0,0,0,0,0,0,0,0],


      // rank_list: 根据当前跑出距离计算出的榜单
      rank_list: [],
      rank_timer: null,

      rank_list_done: [],
    }
  },
  computed: {

    // 
    comp_cfg(){
      let cfg = this.cfg || {}
      return Object.assign({
        num_race_gap: 50,
        ui_height: 600,
        timer_uni: 100, //计时器细粒度
        ui_height_rate: 5,
      },cfg)
    },

    // 跑出最大距离
    ui_raced_max_now(){
      let v = this
      let res = 50
      let num_raced_max = JSON.parse( JSON.stringify(v.num_raced_now) ).sort((a,b)=>{return (b-a)})[0]
      res += num_raced_max

      res = res > v.comp_cfg.num_race_max ? v.comp_cfg.num_race_max : res
      return res
    },

    // 
    ui_line_gap(){
      let v = this

      // 400是ui高度
      let num = parseInt((v.ui_raced_max_now + v.comp_cfg.ui_height)/v.comp_cfg.num_race_gap)

      let arr = [0]
      for(let i = 1; i <= num; i ++){
        arr.push(i*v.comp_cfg.num_race_gap)
      }

      // 终点线
      // if(arr.indexOf((v.race_data[v.time_point_max][0] || 0)) === -1){
      //   let max = v.race_data[v.time_point_max][0]
      //   for(let item of v.race_data[v.time_point_max]){
      //     if(item >= max){
      //       max = item
      //     }
      //   }
      //   arr.push(max)
      // }

      return arr
    },
    
  },
  watch: {},
  methods: {

    initAll(){
      let v = this

      // 重置计时器
      if(v.timer){
        clearInterval(v.timer)
        v.timer = null
      }
      if(v.rank_timer){
        clearInterval(v.rank_timer)
        v.rank_timer = null
      }

      // 重置数据
      v.time_now = 0
      v.time_point_max = 0
      v.time_point_prev = 0
      v.time_point_next = 0
      v.mark_query_data_start = 0

      // 重置数据
      v.num_raced_now = []
      for( let key in v.race_data){
        v.num_raced_now = v.race_data[key]
        break
      }

      // 初始化排名
      let temp_rank_list = []
      for(let i = 1; i <= v.num_raced_now.length; i++){
        v.rank_list.push(i)
      }
      v.rank_list = temp_rank_list

      // 初始化最大时间点
      v.calcTimePointMax()

      console.log('inited')
    },

    calcTimePointMax(){
      let v = this

      // 最大时间点
      v.time_point_max = 0
      for(let key in v.race_data){
        if(key >= v.time_point_max){
          v.time_point_max = parseInt(key)
        }
      }
    },

    // 
    async getRaceRepalyData(){
      let v = this

      if(v.status_geting_race_data){return}
      
      v.status_geting_race_data = true
      let res = await v.api('getRaceRepalyData',{
        raceId: v.race_id,
        duration: v.mark_query_data_start,
      })
      v.status_geting_race_data = false

      if(res.code == 0){

        // 整理数据
        let temp = {}
        for(let key in res.data){
          temp[parseInt(key)] = res.data[key]
        }

        if(v.mark_query_data_start == 0){
          v.race_data = temp
        }else{
          for(let key in temp){
            v.race_data[key] = temp[key]
          }
        }

        // 更新最大时间点
        v.calcTimePointMax()

        v.mark_query_data_start += v.mark_query_data_step
        v.replay()
      }


    },

    replay(){
      let v = this

      if(v.timer){
        console.log('returned')
        return
      }


      // 
      v.initAll()
      v.timer = setInterval(function(){
        v.time_now += v.comp_cfg.timer_uni

        if(v.race_data[v.time_now]){
          // 赋值
          v.runAnimate(v.time_now)
        }

        if(v.time_point_max - v.time_now <= 1000){
          // 赋值
          v.getRaceRepalyData()
        }
        

        // 跑马终止的判断
        // if(v.time_now >= v.time_point_max){
        console.log(v.time_now, v.time_now >= 60000)
        if(v.time_now >= 60000 || v.time_now >= 3000 && v.num_raced_now[0] && !v.num_raced_now.find(i => i !== v.num_raced_now[0])){
          console.log('race end.')
          if(v.timer){
            clearInterval(v.timer)
            v.timer = null
          }

          // 1s 后把排行的运算也停掉
          setTimeout(function(){
            if(v.rank_timer){
              clearInterval(v.rank_timer)
              v.rank_timer = null
            }

            v.$emit('replay2dStoped')
          },4000)
        }
      },v.comp_cfg.timer_uni)
      

      // 判断排名
      // let num_max = v.race_data[v.time_point_max][0]
      v.rank_timer = setInterval(function(){
        let num_raced_now = JSON.parse(JSON.stringify(v.num_raced_now))
        let num_raced_now_arr = []

        for(let i in num_raced_now){
          num_raced_now_arr.push({
            gate: parseInt(i) + 1,
            num: num_raced_now[i],
          })
        }

        console.log(num_raced_now_arr)

        num_raced_now_arr = num_raced_now_arr.sort((a,b) => {

          return b.num - a.num
        })

        v.rank_list = num_raced_now_arr
      },500)

    },

    // 操作动画
    runAnimate(time_point){
      let v = this

      // 下一个时间点
      for(let i = time_point; i <= v.comp_cfg.time_point_max; i += v.comp_cfg.timer_uni){
        if(v.race_data[i]){
          v.time_point_next = i
          break
        }
      }

      // 赋值
      v.num_raced_now = v.race_data[time_point]

    },
  },
  created() {
    let v = this
    v.initAll()

    v.replay()

    return
  },
  //mounted() {},
  beforeDestroy() {
    this.initAll()
  },
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .block-2d{
    position: relative;
    $animate_time: 2s;

    .race-box{
      border-bottom: 10px solid transparent;
      width: 100%;
      margin: 0 auto;
      background-color: rgba(150,150,150, 0.05);
      overflow: hidden;

      .race-map{
        position: relative;
        min-height: 100%;
        transition: height $animate_time linear;
      }

      .line-item{
        $c: rgba(120,120,120,0.3);
        position: absolute;
        width: 90%;
        left: 5%;
        right: 5%;
        border-bottom: 1px solid $c;
        text-align: right;
        color: $c;

        &.no-border{
          border-bottom: none;
        }
      }

      .horse-item{
        width: 20px;
        height: 20px;
        line-height: 20px;
        position: absolute;
        background-color: #888;
        color: #fff;
        font-size: 12px;
        border-radius: 10px;
        display: block;
        text-align: center;
        font-weight: bold;
        transition: bottom $animate_time linear;

        &:nth-child(1){background-color: rgb(168, 57, 57);}
        &:nth-child(2){background-color: rgb(23, 168, 47);}
        &:nth-child(3){background-color: rgb(38, 57, 163);}
        &:nth-child(4){background-color: rgb(48, 122, 64);}
        &:nth-child(5){background-color: rgb(141, 42, 133);}
        &:nth-child(6){background-color: rgb(16, 172, 112);}
        &:nth-child(7){background-color: rgb(49, 20, 104);}
        &:nth-child(8){background-color: rgb(90, 19, 75);}
        &:nth-child(9){background-color: rgb(38, 70, 18);}
        &:nth-child(10){background-color: rgb(25, 138, 72);}
        &:nth-child(11){background-color: rgb(37, 114, 13);}
        &:nth-child(12){background-color: rgb(87, 19, 51);}
      }
    }
  }
</style>